<template>
	<div style="width: 100%;height: 100%;background: #eceef1;">
		<Layout-Top menuName="家庭成员" prevUrl="/WeChat/Person">
			<Icon class="slot" @click="addPersonShow=true" style="margin-top: -2px;" size="28" type="md-person-add" />
		</Layout-Top>
		<!-- <Row type="flex" justify="center" align="center" style="height: 46px;width: 100%; background: #eceef1;line-height: 46px;">
			<Col span="2">
				<Icon style="margin-top: -2px;" size="28" type="ios-arrow-back" />
			</Col>
			<Col span="19">
				家庭成员 
			</Col>
			<Col span="3">
				<Icon @click="addPersonShow=true" style="margin-top: -2px;" size="28" type="md-person-add" />
			</Col>
		</Row> -->
		<Row v-for="person in family" :key="person.pid" type="flex" justify="center" align="center" style="height: 80px;background: #f8f8f9;margin-bottom: 1px;">
			<Col span="5" style="text-align: center;">
				<div style="height: 100%;width: 52px;margin: 0 auto;padding-top: 2px;">
					<img v-if="person.psex=='1'" style="height: 52px;width: 52px;" src="../../../../../assets/image/boy.png" />
					<img v-else style="height: 52px;width: 52px;" src="../../../../../assets/image/girl.png" />
					{{person.prelation}}
				</div>
			</Col>
			<Col span="19">
				<Row type="flex" justify="center" align="center" style="height: 40px;line-height: 40px;">
					<Col span="2">
					</Col>
					<Col span="8">
						姓名:{{person.pname}}
					</Col>
					<Col span="14">
						ID:{{person.pid}}
					</Col>
				</Row>
				<Row type="flex" justify="center" align="center" style="height: 40px;">
					<Col span="2">
					</Col>
					<Col span="8">
						年龄:{{person.page}}
					</Col>
					<Col span="14">
						身份证:{{person.psno}}
					</Col>
				</Row>
			</Col>
		</Row>
		<Modal
			v-model="addPersonShow"
			:mask-closable="false"
			:footer-hide="true"
			:styles="{padding:'8px'}"
			>
			<div slot="header" style="text-align: center;font-size: 18px;">
				新增亲属
			</div>
			<div slot="close"></div>
			<Row type="flex" justify="center" align="center" style="height: 36px;line-height: 36px;">
				<Col span="12" style="text-align: right;font-size: 16px;">
					他(她)是我的:
				</Col>
				<Col span="12">
					 <Select v-model="currRelation" filterable  style="width: 86px;"> 
						<Option v-for="item in Relations" :key="item">{{ item}}</Option>
					</Select>
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="height: 86px;margin-top: 8px;">
				<Col span="2">
				</Col>
				<Col span="10" style="text-align: center;">
					<img style="height: 86px;" src="../../../../../assets/image/wx_sys.png" />
				</Col>
				<Col span="10" style="text-align: center;">
					<img style="height: 86px;" src="../../../../../assets/image/family_idcard.png" />
				</Col>
				<Col span="2">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="height: 26px;line-height: 26px;">
				<Col span="2">
				</Col>
				<Col span="10" style="text-align: center;">
					扫描亲属二维码
				</Col>
				<Col span="10" style="text-align: center;">
					上传亲属身份证
				</Col>
				<Col span="2">
				</Col>
			</Row>
			<Row type="flex" justify="center" align="center" style="margin-top: 16px;">
				<Col span="8" >
				</Col>
				<Col span="8" style="text-align: center;font-size: 18px;">
					<Button @click="addPersonShow=false" style="font-size: 16px;outline: none;box-shadow:none;" type="text" long>取消</Button>
				</Col>
				<Col span="8" >
				</Col>
			</Row>
		</Modal>
	</div>
</template>
<script>
	import Top from '../assembly'
	export default {
		components: {
			'Layout-Top': Top
		},
		data(){
			return {
				addPersonShow:false,
				family:[
					{
						pid:'gdxghg144d1',
						pname:'王申友',
						psex:'1',
						page:48,
						psno:'5125******519',
						prelation:'爸爸'
					},
					{
						pid:'gdhgfw1332',
						pname:'任正珊',
						psex:'0',
						page:50,
						psno:'5125******529',
						prelation:'妈妈'
					}
				],
				Relations:[
					"爸爸",
					"妈妈"
				]
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/views/WeChat/Person/Family/index.vue